import Jobseekers from '@/api/jobseekers'
import filter from './jobseekers-filter'

export default {
  namespaced: true,
  modules: { filter },
  state: {
    jobseekers: [],
    currentJobseeker: null,
    appliedFilter: {},
    keyword: '',
    location: '',
    currentExperiences: [],
    jobSeekersBoard: [],
    jobSeekerLoading: false
  },
  getters: {
    jobseekerById: (state, getters) => (id) => {
      return state.jobseekers.find(seeker => seeker.id === id)
    },
    filterCount: state => {
      return Object.keys(state.appliedFilter).length
    }
  },
  mutations: {
    setCurrentJobseeker (state, to) {
      state.currentJobseeker = to
    },
    setJobseekers (state, jobseekers) {
      state.jobseekers = jobseekers
    },
    resetJobseekers (state) {
      state.jobseekers = []
    },
    resetCurrentJobseeker (state) {
      state.currentJobseeker = null
    },
    setFilter (state, filter) {
      state.appliedFilter = filter
    },
    setKeyword (state, keyword) {
      state.keyword = keyword
    },
    setLocation (state, location) {
      state.location = location
    },
    setCurrentExperiences (state, experiences) {
      state.currentExperiences = experiences
    },
    setJobSeekersBoard (state, jobSeekersBoard) {
      state.jobSeekersBoard = jobSeekersBoard
    },
    setJobSeekerLoading (state, jobSeekerLoading) {
      state.jobSeekerLoading = jobSeekerLoading
    }
  },
  actions: {
    async listJobseekers ({ commit, state }) {
      commit('setJobSeekerLoading', true)
      const data = {
        keyword: state.keyword,
        location: state.location
      }
      const jobseekers = await Jobseekers.list(data)
      commit('setJobseekers', jobseekers)
      commit('setJobSeekerLoading', false)
    },
    async searchJobseekers ({ commit, state }) {
      commit('setJobSeekerLoading', true)
      const data = Object.assign({
        keyword: state.keyword,
        location: state.location
      }, state.appliedFilter)
      const jobseekers = await Jobseekers.search(data)
      commit('setJobseekers', jobseekers)
      commit('setJobSeekerLoading', false)
    },
    async getJobseeker ({ commit, getters, state }, id) {
      const jobseeker = await Jobseekers.getById(id)
      commit('setCurrentJobseeker', jobseeker)
    },
    async applyFilter ({ commit, rootGetters, dispatch, state }) {
      const filter = rootGetters['jobseekers/filter/data']
      commit('setFilter', filter)
      await dispatch('searchJobseekers')
    },
    async clearFilter ({ commit, dispatch, state }) {
      commit('jobseekers/filter/clear', null, { root: true })
      commit('setFilter', {})
      await dispatch('searchJobseekers')
    },
    async getExperiences ({ commit }, id) {
      const experiences = await Jobseekers.getJobseekerExperience(id)
      commit('setCurrentExperiences', experiences)
    },
    async getJobSeekersBoard ({commit}) {
      const jobSeekersBoard = await Jobseekers.getJobSeekersBoard()
      commit('setJobSeekersBoard', jobSeekersBoard.data)
    },
    async getFilterJobSeekers ({commit}, {data, contractTypes, keyword, location}) {
      try {
        commit('setJobSeekerLoading', true)
        const boards = data.map(item => item.id)
        const jobSeekers = await Jobseekers.getFilterJobSeekers({boards, contractTypes, keyword, location})
        commit('setJobseekers', jobSeekers)
        commit('setJobSeekerLoading', false)
      } catch (e) {
        console.log('error', e)
        commit('setJobSeekerLoading', false)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/jobseekers.js